import React from 'react'
// import about from "../assets/imgs/about-right-cause-nonprofit-softwares.webp"
import about from "../../assets/imgs/about-right-cause-nonprofit-softwares.webp"
import aboutIcon from "../../assets/imgs/about-right-cause-icon.webp"
import './css/AboutUs.css'

const AboutUs = () => {
    return (
        <>
            <section id="about_us" className="about_usSection">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6 col-lg-5 about_imgdiv">
                            <img src={about} alt="nonprofit fundraising solutions" width="536" height="537" />
                            <div className="sliderIcon-3">
                                <img width="79" height="65" src={aboutIcon} alt="Right Cause CRM Software" />
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-7 mt-xs-3" data-aos="fade-left">
                            <div className="h3 blueTxt">About Right Cause Nonprofit Software </div>
                            <h2 className="h1">
                                Right Cause is a cloud-based system
                                built on secure Microsoft Cloud.
                            </h2>
                            <p>The solution is aimed at small, medium and large sized nonprofits. It can be customized to
                                bespoke versions to suit the varying needs of non-profit organizations. It can be used
                                across an entire charity or within one department, such as fundraising or service delivery.
                                The system is continually updated and prides itself on powerful reporting and integration
                                capabilities. </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
        
    )
}

export default AboutUs